import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@teach/ui'
import type { UpdateImpact } from '@/features/moderation/types'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  impact: UpdateImpact | null
  onConfirm: () => void
  onCancel: () => void
}

/** Подтверждение «Отправить обновление», когда одобрение сотрёт чужой прогресс:
 *  после слияния черновика прогресс по удалённым и сменившим тип экранам не вернуть. */
export const UpdateImpactDialog = ({ impact, onConfirm, onCancel }: Props) => {
  const m = useMessages(messages)
  const n = impact?.affectedLearners ?? 0
  return (
    <AlertDialog open={impact !== null} onOpenChange={(open) => (open ? undefined : onCancel())}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{m.impactTitle(n)}</AlertDialogTitle>
          <AlertDialogDescription>{m.impactBody}</AlertDialogDescription>
        </AlertDialogHeader>
        {impact ? (
          <div className="space-y-2 text-sm">
            {impact.removedLessons.length > 0 ? (
              <ul className="max-h-[30vh] list-disc space-y-1 overflow-y-auto pl-5">
                {impact.removedLessons.map((l) => (
                  <li key={l.id}>{l.name}</li>
                ))}
              </ul>
            ) : null}
            {impact.removedBlocks.length > 0 ? (
              <p>{m.removedBlocks(impact.removedBlocks.length)}</p>
            ) : null}
            {impact.retypedBlocks.length > 0 ? (
              <p>{m.retypedBlocks(impact.retypedBlocks.length)}</p>
            ) : null}
          </div>
        ) : null}
        <AlertDialogFooter>
          <AlertDialogCancel>{m.cancel}</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>{m.send}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
